import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

export interface FacturacionManualSummary {
  creados: number;
  yaExistian: number;
  mesActual: string;
  mesSiguiente: string;
}

@Injectable({
  providedIn: 'root'
})
export class FacturacionService {

  constructor(private http: HttpClient) { }

  private apiUrl = `${environment.apiUrl}/facturacion`; 
  private apiUrlMeses = environment.apiUrl;
  
  updateMesDeFacturacion(id: number, data: { fecha_inicio: string; fecha_termino: string }) {
    return this.http.put(`${this.apiUrl}/${id}`, data);
  }


  generarFacturacionMensualAutomatica(clienteId: number, anioInicio: number, anios: number): Observable<any> {     
     const url = `${this.apiUrl}/generar-facturacion/${clienteId}/${anioInicio}/${anios}`;
     return this.http.get<any>(url); // O un tipo más específico si lo tienes
   }

  /**
   * Llama al endpoint del backend para generar la facturación mensual para todos los clientes.
   * Devuelve un resumen de la operación.
   */  
  generarFacturacionMensualManual(): Observable<FacturacionManualSummary> {
    return this.http.post<FacturacionManualSummary>(`${this.apiUrl}/generar-facturacion-manual`, {});
  }

  buscarFacturacion(mes: string, id_cliente: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/buscar-facturacion/${mes}/${id_cliente}`);
  }

  // CR-202609-0026 Método para obtener la facturación abierta según fecha y cliente
  obtenerFacturacionAbierta(id_cliente: number, fecha?: string): Observable<any> {
    let url = `${this.apiUrl}/abierta/${id_cliente}`;
    if (fecha) {
      url += `?fecha=${fecha}`;
    }
    return this.http.get<any>(url);
  }

  // Trae directamente las facturaciones de un cliente
  listarFacturacionPorCliente(idCliente: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/${idCliente}`);
  }

  obtenerMesesUnicos() {
    console.log('Llamando al servicio de meses de facturación');
    return this.http.get<string[]>(`${this.apiUrl}/obtener-meses-unicos`);
    
  }

  obtenerFacturaciones() {
    return this.http.get(`${this.apiUrl}/listar`);
  }

  // Cierre de periodo de facturación y traspaso de OTs
  cerrarPeriodo(id_facturacion: number): Observable<any> {
    return this.http.patch<any>(`${this.apiUrl}/${id_facturacion}/cierre`, {});
  }
}

// Interfaz para tipado
interface MesesFacturacion {
  id: number;
  mes: string;
  estado: boolean;
}
